import gql from "graphql-tag";

export const GET_ADDRESS = gql`
    query getAddress {
        user_address{
            id
            address1
            address2
            city
            state
            zip
        }
    }
`;

export const ADD_ADDRESS = gql`
    mutation addAddress($data: user_address_insert_input!) {
        insert_user_address_one(object:$data) {
            id
            address1
            address2
            city
            state
            zip
        }
    }
`;